<template>
  <v-footer :color="this.$primary_color" class="primary-background text-center full-width">
    <v-container class="text-center footer full-width">
      <div>
        <v-btn
            v-for="icon in icons"
            :key="icon.icon"
            class="mx-4"
            :icon="icon.icon"
            :href="icon.link"
            target="_blank"
            variant="text"
        ></v-btn>
      </div>
      <div>
        <v-row>
          <v-col class="d-none d-md-flex" cols="12" sm="12" md="6" lg="6" xl="6" xxl="6">
            <v-img max-height="75" src="/images/logo-sideways-white.png" class="footer" />
          </v-col>
          <v-col class="d-flex" cols="12" sm="12" md="6" lg="6" xl="6" xxl="6">
            <v-card flat class="mx-auto">
              <v-card-text class="text-left footer">
                <div class="">
                  <v-icon :icon="this.$phone_icon" class="me-2" /> 502-653-9589
                </div>
                <div>
                  <v-icon :icon="this.$email_icon" class="me-2" /> sales@handleglobal.com
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div class="mt-6">
        {{ new Date().getFullYear() }} &copy; HANDLE
      </div>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "footerComponent.vue",
  data(){
    return{
      icons: [
        { icon: 'mdi-linkedin', link: 'https://www.linkedin.com/company/handleglobal/' },
        { icon: 'mdi-youtube',link: 'https://www.youtube.com/channel/UCsNxEFu42wXQRsJwyJI2Imw' },
        { icon:'mdi-facebook', link: 'https://www.facebook.com/HANDLEGlobal' },
        { icon: 'mdi-twitter', link: 'https://twitter.com/HandleGlobal' },
      ],
    };
  },
}
</script>

<style scoped>

</style>